import { useInView } from "motion/react";
import { Location } from "../../../providers/routing/types";
import { TextLink } from "../link/TextLink";
import {
  bottomContainer,
  linkContainer,
  mainContainer,
  navigationLink,
  navigationMenu,
  navigationMenuContainer,
} from "./style.css";
import { useRef } from "react";
import { NavigationLink } from "./navigation-link";
import {
  ABOUT_US_PAGE,
  ADVANCED_TECHNOLOGY_PAGE,
  CUSTOM_DESIGN_PAGE,
  CUTTING_COSTS_PAGE,
  SUSTAINABILITY_PAGE,
} from "../../../providers/routing/routes";

type NavigationPanelProps = {
  onNavigate?: (location: Location) => void;
  currentLocation: Location;
};

export const NavigationPanel = ({
  onNavigate,
  currentLocation,
}: NavigationPanelProps) => {
  const menuRef = useRef<HTMLDivElement>(null);

  const handleNavigate = (location: Location) => () => {
    onNavigate?.(location);
  };

  const isInView = useInView(menuRef, { amount: 0.1 });

  return (
    <div
      ref={menuRef}
      data-is-visible={!!isInView}
      className={navigationMenuContainer}
    >
      <div className={navigationMenu}>
        <div className={mainContainer}>
          <NavigationLink
            to={ADVANCED_TECHNOLOGY_PAGE}
            isActive={currentLocation === "inner-technology"}
            shouldAnimate={isInView}
            onClick={handleNavigate("inner-technology")}
          >
            Advanced technology
          </NavigationLink>
          <NavigationLink
            to={CUTTING_COSTS_PAGE}
            isActive={currentLocation === "inner-cutting-costs"}
            shouldAnimate={isInView}
            onClick={handleNavigate("inner-cutting-costs")}
          >
            Cutting costs
          </NavigationLink>
          <NavigationLink
            to={SUSTAINABILITY_PAGE}
            isActive={currentLocation === "inner-sustainability"}
            shouldAnimate={isInView}
            onClick={handleNavigate("inner-sustainability")}
          >
            Sustainability
          </NavigationLink>
          <NavigationLink
            to={CUSTOM_DESIGN_PAGE}
            isActive={currentLocation === "inner-custom-design"}
            shouldAnimate={isInView}
            onClick={handleNavigate("inner-custom-design")}
          >
            Custom design
          </NavigationLink>
          <NavigationLink
            to={ABOUT_US_PAGE}
            isActive={currentLocation === "inner-about-us"}
            shouldAnimate={isInView}
            onClick={handleNavigate("inner-about-us")}
          >
            About us
          </NavigationLink>
        </div>
        <div className={bottomContainer}>
          <div
            className={
              currentLocation === "footer" && isInView
                ? linkContainer.active
                : linkContainer.default
            }
          >
            <TextLink
              className={
                currentLocation === "footer"
                  ? navigationLink.active
                  : navigationLink.default
              }
              onClick={handleNavigate("footer")}
              to="/#footer"
            >
              Contacts
            </TextLink>
          </div>
        </div>
      </div>
    </div>
  );
};
